import { SensitiveDataTypeConfigComponent } from '@framework/engine';

export interface IOmissisDirectiveConfigComponentProps {
  name: string;
}

export function OmissisDirectiveConfigComponent(
  props: IOmissisDirectiveConfigComponentProps,
) {
  return (
    <>
      <SensitiveDataTypeConfigComponent {...props} />
      {/* <FormItem
        name={`${props.name}.enabled`}
        label="Omissis"
        help="Se impostato come nascosto, il dato non sarà visibile durante la consultazione dall'area pubblica da parte di utenti terzi"
      >
        <RadioGroupInput
          name={`${props.name}.enabled`}
          defaultValue={false}
          options={[
            { label: 'Campo pubblico', value: false },
            { label: 'Omissis: nascondi in area pubblica', value: true },
          ]}
        /> 
      </FormItem>*/}
    </>
  );
}
